import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=20332712&scoped=true&"
import script from "./lunbo.vue?vue&type=script&lang=js&"
export * from "./lunbo.vue?vue&type=script&lang=js&"
import style0 from "./lunbo.vue?vue&type=style&index=0&id=20332712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20332712",
  null
  
)

export default component.exports